import React, { useContext, useMemo } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DeleteOutlined, EditOutlined, MultipleStopOutlined, NotInterestedOutlined, VisibilityOutlined } from '@mui/icons-material';
import { CustomWarningDelete } from '../../CustomWarningDelete';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { AuthContext } from '../../../contexts/AuthContext';
import { encontrarModulo } from '../../../helpers/encontrarModulo';
import { useModalStore } from '../../../store/useModalStore';
import { UpdateAssetForm } from './UpdateAssetForm';
import { OffAssetForm } from './OffAssetForm';
import { ViewAssetForm } from './ViewAssetForm';
import { ReAssignForm } from './ReAssignForm';

export const Actions = ({ data, updated, deleted, assign, off }) => {

    const { usuario: { rol: { nombre: rol }, permisos } } = useContext(AuthContext);
    const { openModal } = useModalStore();

    const actions = useMemo(() => {
        return encontrarModulo(permisos, 'activos')?.actions?.filter(a => a?.name !== 'crear')?.map(a => (rol?.includes('admin') || a?.active) ? a : null);
    }, []);

    const buttons = [
        { icon: <VisibilityOutlined color='action' fontSize='small' />, action: () => openModal(<ViewAssetForm data={ data } />) },
        { icon: <EditOutlined color='action' fontSize='small' />, action: () => openModal(<UpdateAssetForm data={ data } action={ (fields) => updated(fields, data?._id) } />)  },
        { icon: <DeleteOutlined color='action' fontSize='small' />, action: () => openModal(<CustomWarningDelete action={ () => deleted(data?._id) } />) },
        { icon: <MultipleStopOutlined color='action' fontSize='small' />, action: () => openModal(<ReAssignForm action={ (field) => assign(field, data?._id, data?.responsable) } user={ data?.responsable?.usuario } />) },
        { icon: <NotInterestedOutlined fontSize='small' />, action: () => openModal(<OffAssetForm data={ data } action={ (fields) => off(fields, data?._id, data?.responsable) } />)  }
    ];

    return (
        <>
            { actions?.map((a, i) => a && (
                <Tooltip key={ a?.name } title={ convertirLetraMayus(a?.name) }>
                    <IconButton aria-label="read" onClick={ buttons[i]?.action }>
                        { buttons[i]?.icon }
                    </IconButton>
                </Tooltip>
            ))}
        </>
    );
}